module.exports = __webpack_public_path__ + "static/media/Navigation_Darker.89175034.png";